<template>
  <div>
    <v-card class="mt-0" width="500">
      <v-container>
        <div class="d-flex">
          <v-img
            src="../../../../assets/logo.png"
            width="200"
            class="mx-auto"
          />
        </div>
        <v-container fluid>
          <h2 class="text-center">Sign Up Via Email or Google</h2>
          <v-row>
            <v-col>
              <v-card
                outlined
                width="175"
                class="d-flex"
                ripple
                @click="provider = 'email'"
                :color="provider == 'email' ? 'grey' : 'primary lighten-2'"
              >
                <v-container>
                  <v-btn icon width="100%" class="mx-auto" disabled>
                    <v-icon x-large>mdi mdi-email</v-icon>
                  </v-btn>
                  <h4 class="mt-2 text-center font-weight-normal">Email</h4>
                </v-container>
              </v-card>
            </v-col>
            <v-col>
              <v-card
                outlined
                width="175"
                class="d-flex"
                ripple
                @click="provider = 'google'"
                :color="provider == 'google' ? 'grey' : 'primary lighten-2'"
              >
                <v-container>
                  <v-btn icon width="100%" class="mx-auto" disabled>
                    <v-icon x-large>mdi mdi-google</v-icon>
                  </v-btn>
                  <h4 class="mt-2 text-center font-weight-normal">Google</h4>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <v-form width="100%">
          <v-row>
            <v-col>
              <label
                class="text-xs text-typo font-weight-bolder ms-1"
                v-if="isEmail"
                >First Name</label
              >
              <v-text-field
                v-model="firstName"
                class="
                  font-size-input
                  border border-radius-md
                  placeholder-lighter
                  text-color-light
                  mb-4
                  mt-2
                "
                outlined
                required
                v-if="isEmail"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col>
              <label
                class="text-xs text-typo font-weight-bolder ms-1"
                v-if="isEmail"
                >Last Name</label
              >
              <v-text-field
                class="
                  font-size-input
                  border border-radius-md
                  placeholder-lighter
                  text-color-light
                  mb-4
                  mt-2
                "
                outlined
                v-model="lastName"
                required
                hide-details
                v-if="isEmail"
              ></v-text-field>
            </v-col>
          </v-row>

          <label class="text-xs text-typo font-weight-bolder ms-1"
            >Company Name</label
          >
          <v-text-field
            class="
              font-size-input
              border border-radius-md
              placeholder-lighter
              text-color-light
              mb-4
              mt-2
            "
            outlined
            v-model="companyName"
            required
            hide-details
          ></v-text-field>
          <label
            class="text-xs text-typo font-weight-bolder ms-1"
            v-if="isEmail"
            >Email</label
          >
          <v-text-field
            class="
              font-size-input
              border border-radius-md
              placeholder-lighter
              text-color-light
              mb-4
              mt-2
            "
            outlined
            v-model="email"
            required
            hide-details
            v-if="isEmail"
          ></v-text-field>
          <label
            class="text-xs text-typo font-weight-bolder ms-1"
            v-if="isEmail"
            >Password</label
          >
          <v-text-field
            v-if="isEmail"
            class="
              font-size-input
              border border-radius-md
              placeholder-lighter
              text-color-light
              mb-0
              mt-2
            "
            outlined
            v-model="password"
            type="password"
            required
            hide-details
          ></v-text-field>
          <span
            class="mt-0 pt-0"
            v-if="password.length > 0 && password.length < 6"
            style="font-size: 0.6em; color: red"
            >Password must be at least 6 characters</span
          >
          <v-btn
            :disabled="
              !companyName || !firstName || !lastName || !email || !password
            "
            :color="
              firstName && lastName && email && password && companyName
                ? 'primary'
                : 'grey'
            "
            dark
            @click="registerWithEmail"
            width="100%"
            v-if="isEmail"
            >Sign Up With Email</v-btn
          >
          <v-btn
            :disabled="!companyName"
            :color="companyName ? 'primary' : 'grey'"
            dark
            @click="registerWithGoogle"
            width="100%"
            v-else
            >Sign Up With Google</v-btn
          >
        </v-form>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import fb from "../../../../plugins/firebase";
const auth = fb.auth;
const GoogleAuthProvider = fb.GoogleAuthProvider;
import db from "../../../../services/auth";
import {
  createUserWithEmailAndPassword,
  signInWithPopup,
  browserPopupRedirectResolver,
} from "firebase/auth";

export default {
  data() {
    return {
      firstName: "",
      lastName: "",
      companyName: "",
      email: "",
      password: "",
      // valid: false,
      // nameRules: [(v) => !!v || "This field is required hide-details"],
      // emailRules: [(v) => !!v || "Email is required hide-details"],
      // passwordRules: [(v) => !!v || "Password is required hide-details"],
      provider: "email",
    };
  },
  computed: {
    isEmail() {
      return this.provider === "email";
    },
  },
  methods: {
    async registerWithEmail() {
      try {
        await this.$store.dispatch("registerUser", {
          firstName: this.firstName,
          lastName: this.lastName,
          companyName: this.companyName,
          email: this.email,
          password: this.password,
        });
      } catch (error) {
        console.error("Error registering with email:", error);
      }
    },
    async registerWithGoogle() {
      const provider = new GoogleAuthProvider();
      try {
        await signInWithPopup(
          auth,
          provider,
          browserPopupRedirectResolver
        ).then((result) => {
          this.$store.dispatch("registerUserWithGoogle", {
            firstName: result.user.displayName ? result.user.displayName.split(" ")[0] : "",
            lastName: result.user.displayName ? result.user.displayName.split(" ")[1] : "",
            companyName: this.companyName,
            email: result.user.email,
            ...result.user,
          });
        });

        this.$router.push("/dashboard");
      } catch (error) {
        console.error("Error registering with Google:", error);
      }
    },
  },
};
</script>

<style scoped>
.v-card {
  max-width: 500px;
  margin: 50px auto;
}
</style>

<!-- <template>
  <v-card class="mt-sm-8 mt-md-5 mt-7 bg-transparent">
    <v-card-title>
      <v-img src="../../../../assets/logo.png" width="200" />
    </v-card-title>
    <div class="card-padding pb-0">
      <h4 class="text-h4 font-weight-bolder text-typo mb-2">
        Register Your Account
      </h4>
    </div>
    <form @submit.prevent="register" class="card-padding pb-4">
      <v-row>
        <v-col>
          <label class="text-xs text-typo font-weight-bolder ms-1"
            >First Name</label
          >
          <v-text-field
            hide-details
            outlined
            light
            height="40"
            placeholder="First Name"
            v-model="firstName"
            class="
              font-size-input
              border border-radius-md
              placeholder-lighter
              text-color-light
              mb-4
              mt-2
            "
          >
          </v-text-field>
        </v-col>
        <v-col>
          <label class="text-xs text-typo font-weight-bolder ms-1"
            >Last Name</label
          >
          <v-text-field
            hide-details
            outlined
            light
            height="40"
            placeholder="Last Name"
            v-model="lastName"
            class="
              font-size-input
              border border-radius-md
              placeholder-lighter
              text-color-light
              mb-4
              mt-2
            "
          >
          </v-text-field>
        </v-col>
      </v-row>
      <label class="text-xs text-typo font-weight-bolder ms-1">Company</label>
      <v-text-field
        hide-details
        outlined
        light
        height="40"
        placeholder="Company"
        v-model="companyName"
        class="
          font-size-input
          border border-radius-md
          placeholder-lighter
          text-color-light
          mb-4
          mt-2
        "
      >
      </v-text-field>
      <label class="text-xs text-typo font-weight-bolder ms-1">Email</label>
      <v-text-field
        hide-details
        outlined
        light
        height="40"
        placeholder="Email"
        v-model="email"
        class="
          font-size-input
          border border-radius-md
          placeholder-lighter
          text-color-light
          mb-4
          mt-2
        "
      >
      </v-text-field>

      <label class="text-xs text-typo font-weight-bolder ms-1">Password</label>
      <v-text-field
        hide-details
        v-model="password"
        outlined
        type="password"
        light
        height="40"
        placeholder="Password"
        class="
          font-size-input
          border border-radius-md
          placeholder-lighter
          text-color-light
          mb-4
          mt-2
        "
      >
      </v-text-field>

      <v-btn
        elevation="0"
        type="submit"
        :ripple="false"
        height="43"
        class="
          font-weight-bold
          text-uppercase
          btn-primary
          py-2
          px-6
          me-2
          mt-7
          mb-2
          w-100
        "
        color="black"
        small
        >Submit</v-btn
      >
    </form>
  </v-card>
</template>
<script>
export default {
  name: "sign-up-illustration",
  data() {
    return {
      checkbox: false,
      email: "",
      password: "",
      firstName: "",
      lastName: "",
      companyName: "",
    };
  },
  compueted: {},
  methods: {
    async register() {
      if (this.email == "" || this.password == "") {
        alert("Please enter email and password");
        return;
      }
      await this.$store.dispatch("registerUser", {
        firstName: this.firstName,
        lastName: this.lastName,
        companyName: this.companyName,
        email: this.email,
        password: this.password,
      });
      // this.$router.push("/dashboard");
    },
  },
  created() {
    //this.$store.dispatch("logout");
  },
};
</script> -->
